import Container from './ComponentContainer/Container';

const Dashboard = () => <Container />;

export default Dashboard;
